import HomeConstants from '../../../home/constants';

export const PATH = '/loads';
export const PAGE_TITLE = 'Cargas';
export const PAGE_TITLE_CARD = 'GestaoCargas';
export const PAGE_TITLE_CARD_SETTINGS = 'Ajustes';
export const PAGE_TITLE_CARD_MANUAL_INPUT = 'Input Manual';
export const NO_INFO_TEXT = '---';

export const LOAD_ID_KEY = 'loadId';

export const INITIAL_PAGE_NUMBER = 1;
export const PAGE_SIZE = 30;
export const LOAD_SELECTION_LIMIT = 100;

export const BREADCRUMB_DATA = [
    {
        label: HomeConstants.PAGE_TITLE,
        href: HomeConstants.PATH,
    },
    {
        label: PAGE_TITLE_CARD,
        href: PATH,
    },
];
